import video from './assets/image 1.png'
import persona from './assets/image 2.png'
import inf from './assets/image 3.png'
import bada from './assets/image 4.png'
import ria from './assets/image 5.png'
import tele from './assets/image 6.png'
//import ambu from './assets/cv.png'
//import ausi from './assets/cv.png'

function CardPartner() {
    const card = [{
        photo: persona,
        text: "Fondazione Clotilde - Cure paleative e terapie del dolore",
        link: 'https://www.fondazioneclotilde.it/'
    },
    {
        photo: inf,
        text: "Neapolisanit - Centro di riabilitazione",
        link: 'https://neapolisanit.com/'
    },
    {
        photo: video,
        text: "AIAS - Associazione Italiana Per L'Assistenza Spastici Onlus",
        link: 'https://www.aiasnola.org/'
    },
    {
        photo: bada,
        text: "Centro medico Moscati - Professionisti della riabilitazione",
        link: 'https://www.centromedicomoscati.it/wp/'
    },
    {
        photo: ria,
        text: "IRFID - Istituto per la ricerca, la formazione e l'informazione sulle disabilità.",
        link: 'https://www.irfid.eu/portal/'
    },
    {
        photo: tele,
        text: "Cooperative",
        link: 'https://www.amarantacoop.it/'
    }
    ]

    return (<>
        {card.map((e) =>

            <div style={{ cursor: 'pointer' }} className="card-pt flex-n" onClick={() => window.open(e.link)}>

                <img alt={e.text} src={e.photo} className="img-card-cv" />
                <div className="text-card-pt">
                    <div>
                        <h4>{e.text}</h4> </div>
                </div>
            </div>
        )}</>
    );
}

export default CardPartner;